<template>
  <button class="change-all-items" @click.prevent="handlerChangeAll">
    <trash16 class="change-all-items__icon" :width="16" :height="16" />
    {{ textButton }}
  </button>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api';

import Trash16 from '@/assets/sprite/svg/16/Trash_16.svg';

export default defineComponent({
  name: 'ChangeAllItems',
  components: { Trash16 },
  props: {
    isDeletedAll: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const textButton = computed(() => (props.isDeletedAll ? 'Восстановить все' : 'Удалить всё'));

    const handlerChangeAll = () => {
      emit('changeAllItems');
    };

    return {
      textButton,
      handlerChangeAll,
    };
  },
});
</script>

<style lang="less">
.change-all-items {
  .button-reset();
  .small();

  display: flex;
  align-items: center;
  justify-content: center;
  color: @gray-dark;
  transition: color @A;

  &:hover,
  &._tap {
    color: @link-hover;
  }

  &__icon {
    fill: @gray-dark;
    margin-right: @size-x2;
  }
}
</style>
